export const swanbot_URL = "https://public.swanbot.wingman.grayswan.io/";

import axios from 'axios';
import { getSwanbotRelayToken, isSwanbotRelayEnabled } from './swanbot_relay.js';

export function load_explorer_swanbot_key() {
  if (isSwanbotRelayEnabled()) {
    return getSwanbotRelayToken();
  }
        return axios.get('/xapi/swanbotkey')
                .then(function (response) {
                        const results = response.data;
                        if (results.status === "success") {
                                const swanbot_key = results.swanbot_key;
                                window.WingmanState.swanbot_key = swanbot_key; 
                        }
                });
}

export function sendMessage(msg) {
  return axios.post('/xapi/message/send', msg, {
                headers: { 'Content-Type': 'application/json' }
        }).then(response => response.data);
}

export function fetchEvents(qs) {
  let events_url = '/xapi/events';
        events_url = qs ? events_url + qs : events_url;
        return axios.get(events_url, {
                headers: { 'Content-Type': 'application/json' }
        }).then(response => response.data);
}

export function fetchSlackChannels() {
  return axios.get('/xapi/slack/channels').then(response => response.data);
}

export function fetchSlackUsers() {
  return axios.get('/xapi/slack/users').then(response => response.data);
}

export function watchSettings() {
  return axios.get('/api/settings').then(response => response.data);
}

export function fetchEventDetails(eventId, secondary) {
  return axios.get(`/api/events/${eventId}/${secondary}`).then(response => response.data);
}

export function fetchApiData() {
  return axios.get('/api/test/apidata').then(response => response.data);
}

export function fetchAuthData() {
  return axios.get('/api/test/authdata').then(response => response.data);
}

export function fetchEventCategories() {
  return axios.get('/xapi/events/cats').then(response => response.data);
}

export function sendCommentAction(payload) {
  return axios.post('/api/comment/action', payload, {
    headers: { 'Content-Type': 'application/json' }
  }).then(response => response.data);
}

export function executeDynamicAction(actionId, payload) {
  return axios.post(`/api/action/${actionId}`, payload, {
    headers: { 'Content-Type': 'application/json' }
  }).then(response => response.data);
}
